import ListingEditPageContainer from './containers/ListingEditPageContainer'

export default ListingEditPageContainer
